<template>
  <div id="myResearch">
    <van-tabs
      class="tabs-main"
      :title-active-color="tabActiveColor"
      v-model="type"
      animated
      swipeable
    >
      <van-tab title="我的研究" name="myResearchDetail">
        <van-tabs
          class="tabs"
          :title-active-color="tabActiveColor"
          v-model="baseObj.myResearchDetail.status"
          :swipe-threshold="6"
          @click="tabsChange"
        >
          <van-tab
            v-for="(item, index) in baseObj.myResearchDetail.statusObj"
            :key="index"
            :name="index"
            :title="item"
          ></van-tab>
        </van-tabs>
        <van-pullRefresh v-model="myResearchDetail.refreshing" @refresh="init">
          <Empty v-if="myResearchDetail.totalCount === 0" />
          <van-List
            v-else
            v-model="myResearchDetail.loading"
            :finished="myResearchDetail.finished"
            @load="onLoad"
          >
            <MyResearchItem
              v-for="item in myResearchDetail.list"
              :key="item.id"
              @click="jumpTo('myResearchDetail', item.id)"
              :detail="{...item,statusName: baseObj.myResearchDetail.statusObj[item.frontStatus]}"
              :badgeClass="{
                    'bg-1': [1, 2].includes(item.frontStatus),
                    'bg-2': [3].includes(item.frontStatus),
                    'bg-3': [4].includes(item.frontStatus),
                    'bg-4': [5].includes(item.frontStatus)
                    }"
            />
            <template #finished>
              <van-divider class="list-bottom-tip">滑到底啦</van-divider>
            </template>
          </van-List>
        </van-pullRefresh>
      </van-tab>
      <van-tab v-if="isAuditRale" title="待审论文" name="paperDetail">
        <van-tabs
          class="tabs"
          :title-active-color="tabActiveColor"
          v-model="baseObj.paperDetail.status"
          :swipe-threshold="6"
          @click="tabsChange"
        >
          <van-tab
            v-for="(item, index) in baseObj.paperDetail.statusObj"
            :key="index"
            :name="index"
            :title="item"
          ></van-tab>
        </van-tabs>
        <van-pullRefresh v-model="paperDetail.refreshing" @refresh="init">
          <Empty v-if="paperDetail.totalCount === 0" />
          <van-List
            v-else
            v-model="paperDetail.loading"
            :finished="paperDetail.finished"
            @load="onLoad"
          >
            <MyResearchItem
              v-for="item in paperDetail.list"
              :key="item.id"
              @click="jumpTo('paperDetail', item.id)"
              :detail="{...item,statusName: baseObj.paperDetail.statusObj[item.status]}"
              :badgeClass="{
                    'bg-1': [1].includes(item.status),
                    'bg-2': [3].includes(item.status),
                    'bg-3': [2].includes(item.status)
                    }"
            />
            <template #finished>
              <van-divider class="list-bottom-tip">滑到底啦</van-divider>
            </template>
          </van-List>
        </van-pullRefresh>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { Empty } from '@/components';
import { mapGetters } from 'vuex';
import MyResearchItem from './components/MyResearchItem';
export default {
  name: 'MyResearch',
  components: { Empty, MyResearchItem },
  data () {
    return {
      type: 'myResearchDetail',
      status: 0,
      ...(() => {
        const obj = {};
        ['myResearchDetail', 'paperDetail'].forEach((item) => {
          obj[item] = {
            list: [],
            pageNo: 1,
            pageSize: 20,
            totalCount: '',
            loading: false,
            finished: false,
            refreshing: false
          };
        });
        return obj;
      })(),
      baseObj: {
        myResearchDetail: {
          apiUrl: 'myResearch/list',
          statusObj: {
            0: '全部',
            1: '审核中',
            2: '待修改',
            3: '拟录用',
            4: '已录用',
            5: '未通过'
          },
          status: 0
        }, // 我的研究
        paperDetail: {
          apiUrl: 'solicit/audit/list',
          statusObj: {
            0: '全部',
            1: '待审稿',
            2: '已审稿',
            3: '重新审稿'
          },
          status: 0
        } // 待审论文
      },
      tabActiveColor: '#FD6466'
    };
  },
  computed: {
    ...mapGetters(['personInfo']),
    // 判断是否为专家
    isAuditRale () {
      const { user } = this.personInfo;
      return user && (user.auditRale || '').split(',').includes('1');
    }
  },
  mounted () {
    const { params: { type }, query: { status } } = this.$route;
    this.type = type || 'myResearchDetail';
    this.status = status || '0';
    this.baseObj[this.type].status = this.status;
    this.init();
  },
  watch: {
    type (newVal) {
      newVal = newVal || 'myResearchDetail';
      this.status = this.baseObj[newVal].status;
      this.$router.replace({ params: { type: newVal }, query: { status: this.status } });
    },
    $route: {
      deep: true,
      handler: function () {
        this.init();
      }
    }
  },
  methods: {
    init () {
      this[this.type] = {
        list: [],
        pageNo: 1,
        pageSize: 20,
        totalCount: '',
        loading: false,
        finished: true,
        refreshing: false
      };
      this.onLoad();
      console.log(this.status, this.type, this[this.type]);
    },
    onLoad () {
      const { type, status, baseObj, [type]: detail } = this;
      this.$http.get(baseObj[type].apiUrl, {
        params: {
          pageNo: detail.pageNo,
          pageSize: detail.pageSize,
          status
        }
      }).then((res) => {
        let data = res.data || {};
        detail.list.push(...(data.result || []));
        detail.pageNo = data.nextPage;
        detail.totalCount = data.totalCount || 0;
        detail.loading = false;
        detail.finished = !data.isHasNext;
        detail.refreshing = false;
      });
    },
    tabsChange (e) {
      this.status = e;
      this.$router.replace({ query: { status: e } });
    },
    jumpTo (type, id) {
      this.$router.push({
        name: 'Contribute',
        params: {
          type
        },
        query: {
          id
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
#myResearch {
  height: 100%;
  /deep/
  .tabs-main {
    height: 100%;
    display: flex;
    flex-direction: column;
    &>.van-tabs__content{
      height: 100%;
      .van-tab__pane{
        height: 100%;
        display: flex;
        flex-direction: column;
      }
    }
    .van-pull-refresh{
      flex: 1;
      height: 0;
      overflow-y: auto;
    }
    .van-tabs__wrap {
      .van-tabs__line {
        height: 0.2rem;
        background: url('~@/assets/images/icon_tab_red.png') no-repeat center center;
        background-size: contain;
      }
    }
    .tabs {
      .van-tabs__wrap {
        .van-tabs__line {
          display: none;
        }
      }
    }
  }

}
</style>